/**
 * Sprint V36 (Sa 14.09.2026) — Fokustyp-Akzent-Theme.
 *
 * Liefert die farbliche Akzent-Palette pro Fokustyp fuer Steckbrief-Kacheln:
 *  - gradient        Top-Line-Gradient (subtle)
 *  - cardBorder      Basis-Border-Klasse (mit Hover-Verstaerkung im Component)
 *  - iconBg          Kategorie-Icon-Badge-Hintergrund
 *  - iconBorder      Kategorie-Icon-Badge-Rand
 *  - iconText        Icon-Farbe (Kategorie-Icon + Chip-Icon)
 *
 * Referenz: /app/design_guidelines.json (dark_mode_colors.fokustyp_accents).
 */
const THEMES = {
  katze: {
    gradient: "bg-gradient-to-r from-transparent via-slate-500/40 to-transparent dark:via-slate-400/40",
    cardBorder: "border-slate-200/80 dark:border-slate-800",
    iconBg: "bg-slate-500/10 dark:bg-slate-400/15",
    iconBorder: "border border-slate-400/30 dark:border-slate-500/40",
    iconText: "text-slate-700 dark:text-slate-300",
  },
  eule: {
    gradient: "bg-gradient-to-r from-transparent via-indigo-500/40 to-transparent dark:via-indigo-400/40",
    cardBorder: "border-slate-200/80 dark:border-slate-800",
    iconBg: "bg-indigo-500/10 dark:bg-indigo-400/15",
    iconBorder: "border border-indigo-500/30 dark:border-indigo-400/40",
    iconText: "text-indigo-600 dark:text-indigo-400",
  },
  biene: {
    gradient: "bg-gradient-to-r from-transparent via-amber-500/40 to-transparent dark:via-amber-400/40",
    cardBorder: "border-slate-200/80 dark:border-slate-800",
    iconBg: "bg-amber-500/10 dark:bg-amber-400/15",
    iconBorder: "border border-amber-500/30 dark:border-amber-400/40",
    iconText: "text-amber-600 dark:text-amber-400",
  },
  hund: {
    gradient: "bg-gradient-to-r from-transparent via-orange-500/40 to-transparent dark:via-orange-400/40",
    cardBorder: "border-slate-200/80 dark:border-slate-800",
    iconBg: "bg-orange-500/10 dark:bg-orange-400/15",
    iconBorder: "border border-orange-500/30 dark:border-orange-400/40",
    iconText: "text-orange-600 dark:text-orange-400",
  },
};

const DEFAULT_THEME = {
  gradient: "bg-gradient-to-r from-transparent via-[var(--fts-primary-bright)]/40 to-transparent",
  cardBorder: "border-slate-200 dark:border-slate-800",
  iconBg: "bg-[var(--fts-primary-bright)]/10 dark:bg-[var(--fts-primary-bright)]/20",
  iconBorder: "border border-[var(--fts-primary-bright)]/30",
  iconText: "text-[var(--fts-primary-bright)]",
};

/** Liefert das Akzent-Theme fuer einen Fokustyp-Slug. */
export function getAccentTheme(slug) {
  const key = String(slug || "").toLowerCase();
  return THEMES[key] || DEFAULT_THEME;
}
